import gql from 'graphql-tag';

import {
  PublicUserFragment,
  ProfileFragment,
  AddressFragment,
  FullDraftContentFragment,
  MetatagFragment,
  ThemeFragment,
  ObjectMetatagFragment,
} from '../fragments';

export default gql`
  ${PublicUserFragment}
  ${ProfileFragment}
  ${AddressFragment}
  ${MetatagFragment}
  ${ObjectMetatagFragment}
  ${ThemeFragment}
  ${FullDraftContentFragment}

  query getDraftContent($id: UUID!) {
    draftContent(_id: $id) {
      ...FullDraftContentFragment
    }
  }
`;
